var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tools-app-wrapper"},[_c('CgImportTemplate',{attrs:{"entry":_vm.ToolsPath,"config":_vm.ToolsConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }